import { type Product } from '@curology/product-service-sdk';
import { Button } from '@curology/ui-components-web/react/Button';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalFooter } from '@curology/ui-components-web/react/Modal/ModalFooter';
import { ModalHeader } from '@curology/ui-components-web/react/Modal/ModalHeader';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import PriceSummary from '@/components/flow/steps/resubscription-checkout/components/priceSummary';
import ProductCard from '@/components/flow/steps/resubscription-checkout/components/productCard';
import { type ProductPriceMap } from '@/components/flow/steps/resubscription-checkout/utils/helpers';
import { type Estimate } from '@/types/purchaseContextToggle/types';

const EditSubscriptionModal: React.FC<{
  estimate: Estimate;
  subscribedProducts: Product[];
  purchaseContextAwareProductPriceMap: ProductPriceMap;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
}> = ({
  estimate,
  subscribedProducts,
  purchaseContextAwareProductPriceMap,
  setShowModal,
  showModal,
}) => {
  return (
    <Modal
      onClose={() => setShowModal(false)}
      open={showModal}
      title={<ModalHeader>Edit your box</ModalHeader>}
      type="light"
      contentStyle="card"
      width={576}
    >
      <ModalContent className="cur-text-center cur-p-0 cur-m-0">
        <div>
          {subscribedProducts.map((product) => {
            return (
              <ProductCard
                key={product.id}
                product={product}
                productPriceMap={purchaseContextAwareProductPriceMap}
                showEditIcon={true}
              />
            );
          })}
        </div>
        <Typography size="meta" className="cur-text-left cur-m-2">
          <b>Want to add more products?</b> You can further edit your box after
          resuming your subscription.
        </Typography>
        <PriceSummary estimate={estimate}></PriceSummary>
      </ModalContent>
      <ModalFooter>
        <Button
          className="cur-w-full"
          data-sentry-id="Close modal"
          onClick={() => setShowModal(false)}
          size="lg"
          buttonType="secondary"
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditSubscriptionModal;
